import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const Office: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 20, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path stroke={color} strokeLinecap="round" strokeWidth="1.711" d="M6.376 16.645V3.355h9.435v13.29H6.376ZM3.333 3.182v13.636M12.994 9.998h-1.487" />
</svg>);
export default Office;